/* @flow */

import * as React from 'react';
import type {FieldArrayProps} from 'redux-form';
import {useQuery} from '@apollo/react-hooks';

import type {GetStagesets as GetStagesetsQuery} from 'nutshell-graphql-types';
import GET_STAGESETS from '../../../lead/queries/get-stagesets.graphql';
import {TriggerLeadFields} from './trigger-lead-fields';

type PipelineFieldsProps = {
    fields: $PropertyType<FieldArrayProps, 'fields'>,
    meta: $PropertyType<FieldArrayProps, 'meta'>,
    formType: 'stageEntered' | 'leadClosed',
};

export function PipelineFields(props: PipelineFieldsProps) {
    const {data} = useQuery<GetStagesetsQuery, {}>(GET_STAGESETS, {
        notifyOnNetworkStatusChange: true,
    });

    const response = data && data.stagesets ? data.stagesets : [];

    return response.length ? (
        <TriggerLeadFields {...props} formType={props.formType} optionFields={response} />
    ) : null;
}
